module.exports = __webpack_public_path__ + "static/media/ca.af259017.svg";